export const VIN_LENGTH = 17;

export interface VinCandidate {
  /** Нормализованный ввод: верхний регистр, без пробелов. */
  vin: string;
  length: number;
  /** true — 17 символов в допустимом для VIN алфавите (без I, O, Q). */
  isComplete: boolean;
}

// Счётчик показываем, когда ввод уже похож на набираемый VIN, а не на артикул:
// только латиница+цифры, есть и буквы и цифры, длина от 10 символов.
const CANDIDATE_MIN_LENGTH = 10;
const CANDIDATE_PATTERN = /^[A-Z0-9]+$/;
const VIN_PATTERN = /^[A-HJ-NPR-Z0-9]{17}$/;

export function parseVinCandidate(raw: string): VinCandidate | null {
  const vin = String(raw || '')
    .toUpperCase()
    .replace(/\s+/g, '');
  if (vin.length < CANDIDATE_MIN_LENGTH || vin.length > VIN_LENGTH) {
    return null;
  }
  if (!CANDIDATE_PATTERN.test(vin) || !/[A-Z]/.test(vin) || !/\d/.test(vin)) {
    return null;
  }

  return {
    vin,
    length: vin.length,
    isComplete: VIN_PATTERN.test(vin)
  };
}
